
import React from "react"
export const Space50v = ({children}) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      gap: '50px',
      margin: '20px 22px 20px 22px'
    }}>
      {children}
    </div>
  )
}